import ConfigurationState from '../../../models/store/modules/configuration-state.model';

export const getters = {
  direction: (state: ConfigurationState) => state && state.direction,
  localeCode: (state: ConfigurationState) =>
    state && `${state.locale.language}-${state.locale.countryCode}`,
  isBookingActive: (state: ConfigurationState) => state && state.bookingActive,
  isRescheduleActive: (state: ConfigurationState) =>
    state && state.rescheduleActive,
  aemFormsHandlerConfig: (state: ConfigurationState) =>
    state && state.aemFormsHandlerConfig,
  cancellationFormConfig: (state: ConfigurationState) =>
    state && state.cancellationFormConfig,
  aemCancellationForm: (state: ConfigurationState) =>
    state.links && state.links.aemCancellationForm,
  isPickMeUpFromHomeActive: (state: ConfigurationState) =>
    state && state.pickMeUpFromHome && state.pickMeUpFromHome.active,
  bookingCancellationLink: (state: ConfigurationState) =>
    state && state.links['booking.cancellation'],
  bookingRescheduleLink: (state: ConfigurationState) =>
    state && state.links['booking.reschedule'],
  aemRequestForm: (state: ConfigurationState) =>
    state && state.links && state.links['aemRequestForm'],
  aemTdFromHomeForm: (state: ConfigurationState) =>
    state && state.links && state.links['aemTdFromHomeForm'],
  aemFormsResources: (state: ConfigurationState) =>
    state && state.aemFormsResources,
  dealerRadius: (state: ConfigurationState) => state && state.dealerRadius,
  dealerRadiusArray: (state: ConfigurationState) =>
    state && state.dealerRadiusArray,
  aemFormsEndpoint: (state: ConfigurationState) =>
    state && state.aemFormsResources,
  initialUnavailableDays: (state: ConfigurationState) =>
    state && state.initialUnavailableDays,
  oneDocActive: (state: ConfigurationState) => state && state.oneDoc.active,
  dealerSearchConfig: (state: ConfigurationState) =>
    state && state.dealerSearch?.config,
  isCo2EmissionAndFuelConsumptionVisibile: (state: ConfigurationState) =>
    state && state.isCo2EmissionAndFuelConsumptionVisibile,
  isEnergyEfficiencyVisibile: (state: ConfigurationState) =>
    state && state.isEnergyEfficiencyVisibile,
};
